import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { LANGS, getLang, setLang, onLangChange } from "../i18n";

const LanguageToggle = ({ compact = false }) => {
  const [lang, setL] = useState(getLang());
  useEffect(() => onLangChange(setL), []);

  return (
    <div
      className="flex items-center gap-1 rounded-full border border-white/15 bg-white/[0.03] p-1"
      data-testid="language-toggle"
      role="group"
      aria-label="Language"
    >
      {!compact && <Globe className="h-3.5 w-3.5 text-gold ml-1.5" />}
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          data-testid={`lang-${l.code}-btn`}
          aria-pressed={lang === l.code}
          title={l.name}
          className={`rounded-full px-2.5 py-1 text-[11px] font-bold font-display tracking-wide transition-all duration-300 ${
            lang === l.code ? "bg-gold text-navy-deep" : "text-slate-400 hover:text-white"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;
